import { patchWixSdk } from '@wix/js-sdk-live-mock';
import 'angular';
import 'angular-dynamic-locale';
import 'angular-translate';
import 'angular-translate-loader-static-files';
import 'bootstrap/dist/css/bootstrap.css';
import 'perfect-scrollbar';
import 'perfect-scrollbar/dist/css/perfect-scrollbar.css';
import './widget.module';
import { debugPanel } from './debugPanel';
import { mockStandalone } from './standalone/standalone';
import './styles/icons.css';
import './styles/layout.css';
import './styles/loader.css';

if (window.top === window) {
  patchWixSdk(window.Wix);
}

mockStandalone();

void debugPanel.start();
